import { Dispatch, SetStateAction, useCallback, useMemo } from 'react';
import { CollapsedSection, ProcessedDiff } from '@components/ncFileVersions/components/NCFileDiffView/types';
import { expandCollapsedSection, ExpansionSourceLines } from '@components/ncFileVersions/components/NCFileDiffView/helpers/expandCollapsedSection';

interface UseExpandSectionParams {
  setProcessedDiff: Dispatch<SetStateAction<ProcessedDiff>>;
  oldContent: string | null;
  newContent: string | null;
}

export const useExpandSection = ({ setProcessedDiff, oldContent, newContent }: UseExpandSectionParams) => {
  const fullLines = useMemo<ExpansionSourceLines>(() => {
    if (!oldContent || !newContent) {
      return { oldLines: [], newLines: [] };
    }
    return { oldLines: oldContent.split('\n'), newLines: newContent.split('\n') };
  }, [oldContent, newContent]);

  return useCallback(
    (section: CollapsedSection) => {
      setProcessedDiff((prev) => expandCollapsedSection(prev, section, fullLines));
    },
    [setProcessedDiff, fullLines],
  );
};
